import { useCallback } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

import { ErrorReportingProvider } from '@highlight-cp/core-ui';
import { APP_ERROR_OUTCOME, reportClientError } from '@highlight-cp/metrics/client';

export function ClientErrorReportingProvider({ children }: { children: ReactNode }) {
  const onError = useCallback((error: Error, _errorInfo: ErrorInfo, componentName?: string) => {
    reportClientError({
      outcome: APP_ERROR_OUTCOME.REACT_BOUNDARY,
      component: componentName,
      message: error.message,
      errorName: error.name,
    });
  }, []);

  return <ErrorReportingProvider onError={onError}>{children}</ErrorReportingProvider>;
}
